import template from "./edit-report.html";

function controller(appState, reportScopeFactory) {
	const ctrl = this;

	ctrl.$onInit = () => {
		ctrl.reportScope = reportScopeFactory.create({
			form: appState.forms.selected,
			report: ctrl.report
		});
	};
}

export default angular
	.module("vesl.screens.edit-report", [])
	.component("editReport", {
		template,
		controller,
		bindings: { report: "<" }
	}).name;
